var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"PointerLock"}},[(_vm.showLock)?_c('div',{staticClass:"PointerLock",on:{"click":_vm.return3DWorld}},[_c('div',{staticClass:"PointerLock__bg"}),_vm._v(" "),_c('div',{staticClass:"PointerLock__text Btn"},[_vm._v("\n        "+_vm._s(_vm.trans('enter'))+"\n      ")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f583700","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/world/elements/PointerLock.vue
// module id = null
// module chunks = 